import React from "react";
import PropTypes from "prop-types";
import styles from "./index.css";

export default function Empty({ children, testId }) {
  return (
    <div className={styles.empty} data-test-id={testId}>
      {children}
    </div>
  );
}

Empty.Title = function EmptyTitle({ children }) {
  return <div className={styles.title}>{children}</div>;
};

Empty.Description = function Description({ children }) {
  return <div className={styles.description}>{children}</div>;
};

Empty.Actions = function EmptyActions({ children }) {
  return <div className={styles.actions}>{children}</div>;
};

Empty.propTypes = {
  children: PropTypes.node,
  testId: PropTypes.string,
};

Empty.Title.propTypes = {
  children: PropTypes.node,
};

Empty.Description.propTypes = {
  children: PropTypes.node,
};

Empty.Actions.propTypes = {
  children: PropTypes.node,
};



// WEBPACK FOOTER //
// ./src/components/Empty/index.js